import { unprocessReport } from '@/store/utils/reportUtils'

function serializeForJsonFile (template) {
  const denormalized = unprocessReport(template)
  return JSON.stringify(denormalized, replacer, 2)
}

const replacer = (key, value) =>
  value instanceof Object && !(value instanceof Array)
    ? Object.keys(value)
      .sort(sort)
      .reduce((sorted, key) => {
        sorted[key] = value[key]
        return sorted
      }, {})
    : value

const startWith = ['code', 'name', 'latinName', 'title', 'latinTitle', 'colAxisCode', 'colAxisVersion', 'rowAxisCode', 'rowAxisVersion', 'rowTitle', 'latinRowTitle', 'notes', 'latinNotes']
const endWith = ['cols', 'rows', 'cells']
function getWeight (name) {
  return (startWith.indexOf(name) + 1) + ((endWith.indexOf(name) + 1) * 1000)
}
function sort (a, b) {
  const aWeight = getWeight(a)
  const bWeight = getWeight(b)
  if (aWeight > 0 && bWeight > 0) return aWeight - bWeight
  if (aWeight > 0) return 1
  if (bWeight > 0) return -1
  else return (a < b) + 500
}

export {
  serializeForJsonFile
}



// WEBPACK FOOTER //
// ./src/components/reportDesigner/utils.js